import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

export const config = { // Configure Firebase
  apiKey: "AIzaSyDDM5GsaB2pl5VYSrvTHlQB7G_PvtmHVFY",
  authDomain: "locker.sticksports.io",
  databaseURL: "https://blockchaindev-211114.firebaseio.com",
  projectId: "blockchaindev-211114",
  storageBucket: "sticksports-lockerroom",
  messagingSenderId: "323225247651"
};

// Configure FirebaseUI.
let _uiConfig = {
  // We will display Google and Facebook as auth providers.
  signInOptions: [
    // firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    firebase.auth.FacebookAuthProvider.PROVIDER_ID
    // firebase.auth.TwitterAuthProvider.PROVIDER_ID
  ],
  callbacks: {
    // Avoid redirects after sign-in.
    signInSuccessWithAuthResult: () => false
  }
};

// Popup signin flow rather than redirect flow in non-WebView
if (typeof window.SOFA === 'undefined') {
  _uiConfig.signInFlow = 'popup';
}

export const uiConfig = _uiConfig;

firebase.initializeApp(config);

const databaseRef = firebase.database().ref();

export const authRef = firebase.auth();
export const blockchainRef = databaseRef.child('blockchain');



// WEBPACK FOOTER //
// ./src/config/firebase.js